module.exports = __webpack_public_path__ + "static/media/0_2019_12_26.bc4ae271.jpg";